import { render, staticRenderFns } from "./Main_menuPhone.vue?vue&type=template&id=cb2238d4&scoped=true"
import script from "./Main_menuPhone.vue?vue&type=script&lang=js"
export * from "./Main_menuPhone.vue?vue&type=script&lang=js"
import style1 from "./Main_menuPhone.vue?vue&type=style&index=1&id=cb2238d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2238d4",
  null
  
)

export default component.exports